import axios from "axios";

// Recurring invoice profiles (Starlink subscriptions & any recurring billing)
// plus the pending-review queue of generated-but-unreleased invoices.
const state = {
  profiles: [],
  deleted_profiles: [],
  pending: [],
};

const getters = {
  profiles: (state) => state.profiles,
  deleted_profiles: (state) => state.deleted_profiles,
  pending: (state) => state.pending,
};

const actions = {
  async get_profiles({ commit }, params = {}) {
    const response = await axios.get("/recurring_invoice_profiles", { params });
    commit("SET_PROFILES", response.data);
    return response.data;
  },

  async get_profile(_ctx, id) {
    const response = await axios.get(`/recurring_invoice_profile/${id}`);
    return response.data;
  },

  async create_profile({ dispatch }, payload) {
    const response = await axios.post("/recurring_invoice_profile", payload);
    await dispatch("get_profiles");
    return response.data;
  },

  async update_profile({ dispatch }, { id, payload }) {
    const response = await axios.put(
      `/recurring_invoice_profile/${id}`,
      payload
    );
    await dispatch("get_profiles");
    return response.data;
  },

  async pause_profile({ dispatch }, id) {
    const response = await axios.put(`/recurring_invoice_profile/${id}/pause`);
    await dispatch("get_profiles");
    return response.data;
  },

  async resume_profile({ dispatch }, id) {
    const response = await axios.put(`/recurring_invoice_profile/${id}/resume`);
    await dispatch("get_profiles");
    return response.data;
  },

  async delete_profile({ dispatch }, id) {
    const response = await axios.delete(`/recurring_invoice_profile/${id}`);
    await dispatch("get_profiles");
    return response.data;
  },

  async get_deleted_profiles({ commit }, params = {}) {
    const response = await axios.get("/recurring_invoice_profiles/deleted", {
      params,
    });
    commit("SET_DELETED_PROFILES", response.data);
    return response.data;
  },

  async restore_profile({ dispatch }, id) {
    const response = await axios.put(
      `/recurring_invoice_profile/${id}/restore`
    );
    await Promise.all([
      dispatch("get_profiles"),
      dispatch("get_deleted_profiles"),
    ]);
    return response.data;
  },

  // Manually run the daily recurring-invoice generation (same as the
  // `invoices:generate-recurring` command). Idempotent: already-billed periods
  // are skipped, so clicking it twice never duplicates. Refreshes the pending
  // queue + profiles afterward.
  async generate_now({ dispatch }) {
    const response = await axios.post("/recurring_invoices/generate");
    await Promise.all([dispatch("get_pending"), dispatch("get_profiles")]);
    return response.data;
  },

  // Delete a pending-review invoice (never-released draft). Refreshes the queue.
  async discard_pending({ dispatch }, invoiceId) {
    const response = await axios.delete(
      `/recurring_invoices/${invoiceId}/pending`
    );
    await dispatch("get_pending");
    return response.data;
  },

  async get_pending({ commit }, params = {}) {
    const response = await axios.get("/recurring_invoices/pending", { params });
    commit("SET_PENDING", response.data);
    return response.data;
  },

  async release_invoice({ dispatch }, invoiceId) {
    const response = await axios.put(
      `/recurring_invoices/${invoiceId}/release`
    );
    await dispatch("get_pending");
    return response.data;
  },
};

const mutations = {
  SET_PROFILES(state, profiles) {
    state.profiles = profiles;
  },
  SET_DELETED_PROFILES(state, profiles) {
    state.deleted_profiles = profiles;
  },
  SET_PENDING(state, pending) {
    state.pending = pending;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
